import * as PowerBI from 'powerbi-client';
import * as PowerBIExtensions from './powerbi-extensions';
import { DashboardPlugin } from './dashboard-plugin.interface';

export class SelectionFixPlugin implements DashboardPlugin {
  private designAlreadyFixed: boolean = false;
  private acquisitionAlreadyFixed: boolean = false;
  private currentInterventionContainer: string = null;

  private wellSelectionPages: string[] = ['ByWells'];
  private acquisitionSelectionPages: string[] = ['byUploads', 'Job Search - eMail'];
  private readonly acquisitionIdColumnName = 'Acquisition Name';

  register(report: PowerBI.Embed): void {
    report.on('pageChanged', () => {
      this.acquisitionAlreadyFixed = false;
      this.designAlreadyFixed = false;
    })

    report.on('dataSelected', event => {
      const detail = event.detail as any;
      const currentPage = detail?.page?.displayName;
      if (this.acquisitionSelectionPages.includes(currentPage) && detail?.dataPoints?.length === 1) {
        const containerId = detail.dataPoints[0].identity.filter(x => x.target.column === this.acquisitionIdColumnName)[0].equals;
        this.currentInterventionContainer = containerId;
      } else if (this.wellSelectionPages.includes(currentPage)) {
        this.currentInterventionContainer = null;
      }
    });

    report.on('visualRendered', async event => {
      const visuals = await PowerBIExtensions.getVisuals(report);
      const visual = visuals.filter(x => x.name === (event.detail as any).name)[0];
      if (!visual || visual.type !== "slicer") {
        return;
      }

      if (!this.acquisitionAlreadyFixed && visual.title === 'interventionslicer') {
        this.setSlicerValue(visual, this.currentInterventionContainer);
        this.acquisitionAlreadyFixed = true;
      }

      if (!this.designAlreadyFixed && visual.title === 'designslicer') {
        this.setSlicerValue(visual, null);
        this.designAlreadyFixed = true;
      }
    });
  }

  private async setSlicerValue(visual: any, newValue: string) {
    let slicerState = await visual.getSlicerState();
    slicerState.filters = [];
    if (newValue) {
      slicerState.filters.push({
        target: {
          table: slicerState.targets[0]?.table,
          column: this.acquisitionIdColumnName
        },
        operator: 'In',
        values: [newValue],
      });
    }

    visual.setSlicerState(slicerState);
  }
}
